<script>

import Multiselect from 'vue-multiselect'
import { usersMethods, authComputed } from '@state/helpers'

import { required } from 'vuelidate/lib/validators'

export default {
  name: 'UserSelector',
  components: {
    Multiselect, 

  },
  props: {
    value: {
      required: false,
      default: ()=>(''),
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    description : {
      type: String,
      required: false,
      default: '',
    },
    thirdpartyId : {
      type: Number,
      required: false,
      default: null,
    },
    disabled : {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      userOptions: [],
      loadingUserOptions: false,
      userOptionsMounted: true,
      userOptionsCache: []
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  watch: {
    thirdpartyId(value) {
      if (value) {
        this.populateUserOptions()
      }
    }
  },

  mounted: function () {
    let context = this
    // context.populateUserOptions()
  },

  methods: {
    ...usersMethods,

    getNameOption(optionId) {
      let context = this
      let optionFound = context.userOptions.find(x => x.id === optionId)
      if (optionFound.first_name && optionFound.last_name) {
        return  `${optionFound.first_name} ${optionFound.last_name}`
      }
      return false


    },

    getUsernameOption(optionId) {
      let context = this
      let optionFound = context.userOptions.find(x => x.id === optionId)
      console.log("hola")
      return optionFound.username

    },

    populateUserOptions(searchQuery){
      let context = this
      context.loadingUserOptions = true
      let reqParams = context.$select_params(searchQuery)
      if (context.thirdpartyId){
        reqParams += `&user_info__thirdparty=${context.thirdpartyId}`
      }
      const promise = context.fetchUserOptions(reqParams)
      return promise.then(data => {
          let listOptions = []
          data.results.forEach(opt => {
              listOptions.push({
                  'id': opt.id,
                  'username': opt.username,
                  'first_name': opt.first_name,
                  'last_name': opt.last_name,
                  'email': opt.email,
              })
          });
          context.userOptions = listOptions
          context.loadingUserOptions = false
          context.userOptionsMounted = true
      }).catch(error => {
          context.$axios_error_noty(error, context)
          context.loadingUserOptions = false
          context.userOptionsMounted = true
      })
    },

    asyncFindUser: _.debounce(function (searchQuery) {
        this.populateUserOptions(searchQuery)
    }, 600),

    labelOfUser(opt){
      let context = this
      let optionFound = context.userOptions.find(x => x.id === opt)
      if (!optionFound){
          let cacheFound = context.userOptionsCache.find(x => x.id === opt)
          return  cacheFound ? cacheFound.username : context.userOptionsMounted ? `${ 'label_not_found' }: ${opt}`: ''
      }else{
          if (context.inputVal === opt){
              if (!context.userOptionsCache.find(x => x.id === opt)){
                  context.userOptionsCache.push(optionFound)
              }
          } 
          return optionFound.username
      }
    },
    
  },
}
</script>

<template>
  <b-container class="p-0">

    <b-form-group :label="$t(`user`)" :description="description">
      <b-row>
        <b-col :md="12">
          <Multiselect
              v-model="inputVal"
              :multiple="true"
              :disabled="disabled"
              :options="userOptions.map(x => x.id)" 
              :custom-label="opt => labelOfUser(opt)"
              :loading="loadingUserOptions"
              :internal-search="false"
              :selected-label="$t('selected')"
              :select-label="$t('press_enter_to_select')"
              :deselect-label="$t('press_enter_to_remove')"
              :placeholder="$t('select_option')"
              @search-change="asyncFindUser">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span  v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span>
              </template>
              <template v-slot:option="props">
                <div>
                  <p v-if="getNameOption(props.option)"
                  class="p-0 m-0 font-italic">
                    {{ getNameOption(props.option) }}
                  </p>
                <p :class="{'text-muted': getNameOption(props.option),
              'font-italic': getNameOption(props.option)}"
                class="p-0 m-0">{{ getUsernameOption(props.option)}}</p>
                </div>
              </template>
          </Multiselect>
        </b-col>
      </b-row>
    </b-form-group>

  </b-container>
</template>
<style lang="scss">
.multiselect__tags {
	min-height: 38px;
	display: block;
	max-height: 30px;
	padding: 6px 40px 0 8px;
	border-radius: 5px;
	border: 1px solid #0570a7;
	background: #fff;
	font-size: 14px
}

.multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select {
  background: none;
}

.multiselect--disabled {
  opacity: .3;
}
</style>